export const formatErrorMessage = (
	message: string | string[] | null | undefined
): string => {
	if (!message) return 'An error has occurred. Please try again later.';
	if (Array.isArray(message)) {
		return message.join('\n');
	} else {
		return message;
	}
};
